/*
Bulk upload patients
 */
import {Request} from "mssql";
import {ApplicationScope} from "../ApplicationScope";
import * as csv from 'json2csv';
import {R4Patient} from "../R4Patient";

export const bulkUploadPatients = async (applicationScope: ApplicationScope, minimumId: number, maximumId: number) => {
  try {
    const req: Request = await applicationScope.connectionPool.request();

    req.input('minimumPatientCode', minimumId);
    req.input('maximumPatientCode', maximumId);

    const result = await req.query(`
  SELECT 
  p.patientCode as patient_code,
      p.surname as family_name,
      p.forename as given_name,
      convert(varchar, p.dob, 23) as date_of_birth,
      p.mobileNo as mobile_number,
      p.email as email_address,
      a.address1 as address_line_1,
      a.address2 as address_line_2,
      a.address3 as address_line_3,
      a.address4 as address_line_4,
      a.address5 as address_line_5,
      a.postcode
      
    FROM patients p 
      left join addresses a on p.addressId = a.addressId
      
    WHERE 
      a.postcode is not null and a.address1 is not null and
      a.postcode <> '' and a.address1 <> '' and p.surname <> ''  and p.forename <> '' and
      p.patientCode >= @minimumPatientCode and p.patientCode <= @maximumPatientCode
    `);

    if (result.recordset.length === 0) {
      applicationScope.logging.log({
        message: 'No patients found for bulk upload!'
      });
      return;
    }

    const csvData: R4Patient[] = result.recordset.map(row => {

      const addressLine3 = row['address_line_3'];
      const addressLine4 = row['address_line_4'];
      const addressLine5 = row['address_line_5'];

      return {
        id: row['patient_code'].toString(),
        familyName: row['family_name'],
        givenName: row['given_name'],
        dateOfBirth: row['date_of_birth'],
        mobileNumber: row['mobile_number'] || null,
        emailAddress: row['email_address'] || null,
        addressLine1: row['address_line_1'],
        addressLine2: row['address_line_2'],
        city: addressLine3 && addressLine4 ? `${addressLine3}, ${addressLine4}` : (addressLine3 || addressLine4),
        county: addressLine5,
        postcode: row['postcode'],

        // Hard-coded
        country: 'UK'
      }
    });
    console.log(`sync patient from ${minimumId} to ${maximumId} with ${csvData.length} results`);
    const csvText = csv.parse(csvData, {header: true});
    await applicationScope.flynotesServer.patientBulkUpload(csvText, applicationScope.licenceKey);
  } catch (e) {
    applicationScope.logging.log({
        message: 'Bulk upload failed',
        error: e
      },
      'error')
  }
};

const CHUNK_SIZE = 500;

export const bulkUploadPatientsChunked = async (applicationScope: ApplicationScope, startingIndex: number): Promise<number> => {

  const result = await applicationScope.connectionPool.request().query(
    `SELECT max(p.patientCode) as max_patient_code, min(p.patientCode) as min_patient_code from patients p`
    );
    
    const maxPatientCode = result.recordset[0]['max_patient_code'];
    const minPatientCode = result.recordset[0]['min_patient_code'];

    console.log(`bulkUploadPatientsChunked start ${startingIndex} & result ${JSON.stringify(result)}`)

  if (!maxPatientCode) {
    applicationScope.logging.log({
      message: 'No patients found for bulk upload!',
      maxPatientCode
    });
    return 0;
  }

  // Codes don't start at 0, so we can save some time by going straight to minPatientCode
  let index = minPatientCode > startingIndex ? minPatientCode : startingIndex;

  console.log(`patient sync index ${index} maxPatientCode ${maxPatientCode}`)
  while (index < maxPatientCode) {
    await bulkUploadPatients(applicationScope, index, index + CHUNK_SIZE);
    index += CHUNK_SIZE;
  }

  return maxPatientCode
};
